import React, { useEffect, useState } from "react";
import { pub, P } from "@/lib/publicApi";
import ComplaintForm from "@/components/public/ComplaintForm";
import CommendationForm from "@/components/public/CommendationForm";

// Landing for a scanned officer QR: shows who the feedback is about, lets the citizen pick complaint or commendation.
export default function FeedbackLanding({ code, onNavigate }) {
  const [info, setInfo] = useState(null);
  const [err, setErr] = useState("");
  const [kind, setKind] = useState(null);
  useEffect(() => {
    pub.get(`/feedback/${code}`).then((r) => { setInfo(r.data); if (r.data.kind !== "either") setKind(r.data.kind); })
      .catch((e) => setErr(e.response?.data?.detail || "This QR code could not be verified."));
  }, [code]);

  if (err) return (
    <div data-testid="feedback-invalid" className="max-w-xl mx-auto text-center space-y-4">
      <h2 className="text-xl font-bold" style={{ color: P.navy }}>QR code not valid</h2>
      <p className="text-sm" style={{ color: P.dim }}>{err}</p>
      <div className="flex gap-2 justify-center">
        <button onClick={() => onNavigate("/public/complaint")} className="px-4 py-2 text-sm font-semibold text-white" style={{ background: P.navy }}>File a complaint</button>
        <button onClick={() => onNavigate("/public/commendation")} className="px-4 py-2 text-sm font-semibold text-white" style={{ background: P.gold }}>Submit a commendation</button>
      </div>
    </div>
  );
  if (!info) return <div className="text-center text-sm" style={{ color: P.dim }}>Verifying QR code…</div>;

  const prefill = { officer_name: info.officer_name, badge_number: info.badge, unit_number: info.unit, cad_number: info.incident_cc, agency: info.agency, qr_code: info.code };
  return (
    <div className="max-w-2xl mx-auto space-y-6">
      <div data-testid="feedback-officer-banner" className="rounded-sm border p-4" style={{ borderColor: P.line, background: "#fff" }}>
        <div className="text-[10px] font-bold uppercase tracking-[0.2em]" style={{ color: P.gold }}>Feedback about your contact with</div>
        <div className="text-lg font-bold mt-1" style={{ color: P.navy }}>{info.officer_name}{info.badge ? ` · Badge ${info.badge}` : ""}</div>
        <div className="text-sm" style={{ color: P.dim }}>{[info.agency, info.unit ? `Unit ${info.unit}` : null, info.incident_cc ? `CAD# ${info.incident_cc}` : null].filter(Boolean).join(" · ")}</div>
        <div className="text-xs mt-2" style={{ color: P.dim }}>This QR code was provided by the officer or their supervisor. Your submission goes to Matcom Internal Affairs / Community Relations — not to the officer. Anonymous submissions are accepted.</div>
      </div>
      {!kind ? (
        <div className="grid sm:grid-cols-2 gap-3">
          <button data-testid="feedback-pick-commendation" onClick={() => setKind("commendation")} className="p-5 text-left rounded-sm border-2 hover:shadow" style={{ borderColor: P.gold, background: "#fff" }}>
            <div className="text-base font-bold" style={{ color: P.navy }}>Say thank you — Commendation</div>
            <div className="text-xs mt-1" style={{ color: P.dim }}>Recognize exceptional service, professionalism or compassion.</div>
          </button>
          <button data-testid="feedback-pick-complaint" onClick={() => setKind("complaint")} className="p-5 text-left rounded-sm border-2 hover:shadow" style={{ borderColor: P.navy, background: "#fff" }}>
            <div className="text-base font-bold" style={{ color: P.navy }}>Report a concern — Complaint</div>
            <div className="text-xs mt-1" style={{ color: P.dim }}>Conduct, use of force, discourtesy, or any policy concern. Reviewed by Internal Affairs.</div>
          </button>
        </div>
      ) : kind === "complaint" ? <ComplaintForm onNavigate={onNavigate} prefill={prefill} /> : <CommendationForm onNavigate={onNavigate} prefill={prefill} />}
    </div>
  );
}
